import React, {FC, useState, useEffect} from "react"

import adminTracking from "@irati-tracking/admin"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import GenericModal from "@irati/ui/src/GenericModal"
import {TextArea} from "@irati/ui/src/FormItem"
import validation from "@irati/utils/validation"
import Form from "@irati/ui/src/Form"

const SSO_OTHER = "SSO_selectOther"

interface Props {
  show: boolean,
  onClose: () => void
}

const OtherSSOModal: FC<Props> = ({show, onClose}) => {
  const [showModal, setShowModal] = useState<boolean>(show)
  const [otherProvider, setOtherProvider] = useState<string>("")

  const handleSubmit = () => {
    adminTracking.startIntegrationsSSOJourney(SSO_OTHER, otherProvider)
    handleClose()
  }

  const handleClose = () => {
    setShowModal(false)
    onClose()
  }

  useEffect(() => {
    setShowModal(show)
  }, [show])

  return (
    <GenericModal hideActions show={showModal} onHide={handleClose} onExited={handleClose}>
      <H3 marginBottom={1}>
        <FormattedMessage id="admin.components.integration.sso.editSSO.otherModal.title" />
      </H3>
      <Body marginBottom={3}>
        <FormattedMessage id="admin.components.integration.sso.editSSO.otherModal.subTitle" />
      </Body>
      <Form>
        <TextArea
          name="other"
          hideLabel
          value={otherProvider}
          onChange={(value) => setOtherProvider(value)}
          validation={validation.string("platform.defaultValidation.required")} />
      </Form>
      <Flex justifyContent="flex-end">
        <Button onClick={handleClose} marginRight={1}>
          <FormattedMessage id="admin.components.areYouSurePopUp.button.cancel" />
        </Button>
        <Button primary onClick={handleSubmit} disabled={!otherProvider}>
          <FormattedMessage id="admin.dashboard.integrations.feedback.button.confirm" />
        </Button>
      </Flex>
    </GenericModal>
  )
}

export default OtherSSOModal
